// extracted by mini-css-extract-plugin
export var modal = "_i5-0";